import { useMutation } from "@/compat/reactQuery";
import riskAssessmentAiService from "../../services/riskAssessmentAiService";

const useSendRiskAssessmentAiMessage = () =>
    useMutation(riskAssessmentAiService.sendMessage);

export default useSendRiskAssessmentAiMessage;
